import React from 'react';
import Modal from 'app/blocks/Modal/Modal';

export default () => (
    <Modal hideCloseButtonInHeader id="waiting-dialog-modal">
        <div className="loading">loading...</div>
        <div className="modal-body spinner" data-seleniumid="modal-body" />
    </Modal>
);
